module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment01-ea0e02e2349c8469305eb867ee46a13f.png";